<template>
  <div class="container">
    <Head />
    <main>
      <router-view/>
    </main>
    <Footer />
    <a-back-top :visibilityHeight="1000" />
  </div>
</template>

<script>
// import Search from "@/components/search/search.vue";
import Head from "@/components/head/head.vue";
import Footer from '@/components/footer/footer.vue';

export default {
  name: "HomeNewPage",
  components: { Head, Footer },
  data() {
    return {
      activeIndex: 0,
      keyword: "",
    };
  },
  methods: {
    changeMenu(item, index) {
      if (this.$route.path !== item.path) {
        this.activeIndex = index;
        const router = {
          path: item.path,
          query: {}
        }
        if (item.code) router.query.code = item.code
        this.$router.push(router);
      }
    },
    goDetail(item) {
      console.log(item);
      if (item.editType == '1') window.open(item.htmlPath)
    },

    updateRdtt(rdtt) {
      this.rdtt = rdtt;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  max-width: 1920px;
  margin: 0 auto;
  // background-color: transparent;
  background: #f3f3f3;
  //   background-color: rgba(7, 72, 153);

}

// .active {
//   background: url("@/assets/img/menuAc.png") no-repeat !important;
//   background-size: 100% 100% !important;
// }
</style>
